import Header from "../../Components/Header";
import {useNavigate} from "react-router";
import {useEffect, useRef, useState} from "react";
import InputMask from "react-input-mask";
import moment from 'moment';
import Loader from "../../Components/Loader";
import ErrorDialog from "../../Components/ErrorDialog";
import {COUNTRIES, MENUS, PLACEHOLDER_CAMERA} from "../../constants";
import {getAllStaffById, updateStaffDetail, uploadFile} from "../../API";
import {getUser, setUserData} from "../../DB";
import withUserAuth from "../../Behavior/withUserAuth";
import {validateEmail} from "../../Utils";
import SideMenu from "../../Components/SideMenu";
import $ from "jquery";

const DATE_INPUT_FORMAT = 'YYYY-MM-DD';
const DATE_OUTPUT_FORMAT = 'MM/DD/YYYY';

const Profile = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [imageUrl, setImageUrl] = useState(PLACEHOLDER_CAMERA);
    const [imageFile, setImageFile] = useState(null);
    const imageInputRef = useRef();
    const [name, setName] = useState('')
    const [surname, setSurname] = useState('')
    const [email, setEmail] = useState('')
    const [phonenumber, setPhone] = useState('');
    const [note, setNote] = useState('');

    const [hasMore, setHasMore] = useState(false);
    const [gender, setGender] = useState('0');
    const [birthdate, setBirthdate] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [postal, setPostal] = useState('');
    const [country, setCountry] = useState('');

    const [staff, setStaff] = useState({})

    const handleRemoveImage = (e) => {
        e.stopPropagation();
        setImageUrl(() => staff?.imageurl || PLACEHOLDER_CAMERA);
        setImageFile(null);
    }

    const sendAPIRequest = async () => {
        const staffid = getUser().userid;
        const {code, data, error} = await getAllStaffById({staffid});
        if (code === 200) {
            setImageUrl(data.staff?.imageurl || PLACEHOLDER_CAMERA);
            setStaff(data.staff);
            setName(data.staff?.name || '');
            setSurname(data.staff?.surname || '');
            setEmail(data.staff?.email || '');
            setPhone(data.staff?.phonenumber || '');
            setNote(data.staff?.note || '');
            setGender(data.staff?.gender || '0');
            if (data.staff?.birthdate) setBirthdate(moment(data.staff?.birthdate, DATE_INPUT_FORMAT).format(DATE_OUTPUT_FORMAT));
            setAddress(data.staff?.address || '');
            setCity(data.staff?.city || '');
            setPostal(data.staff?.postal || '');
            setCountry(data.staff?.country || '');
        } else {
            setError(error);
        }
        setLoading(false);

    }

    useEffect(() => {
        sendAPIRequest();
    }, [])

    const handleSave = async () => {

        if (!validateEmail(email)) {
            setError('Email is invalid');
            return;
        }

        if (birthdate && !moment(birthdate, DATE_OUTPUT_FORMAT).isValid()) {
            setError('Birthdate is invalid. Please verify the format');
            return;
        }
        const parsed = moment(birthdate, DATE_OUTPUT_FORMAT);
        console.log('date', moment(birthdate, DATE_OUTPUT_FORMAT));
        debugger;
        const newStaff = {
            ...(staff.userid ? {userid: staff.userid} : {}),
            imageurl: imageUrl,
            name,
            surname,
            email,
            phonenumber,
            note,
            gender,
            birthdate: moment(birthdate, DATE_OUTPUT_FORMAT).isValid() ? moment(birthdate, DATE_OUTPUT_FORMAT).format(DATE_INPUT_FORMAT) : '',
            address,
            city,
            postal,
            country,
        }
        setLoading(true);
        if (imageUrl !== PLACEHOLDER_CAMERA && imageUrl !== staff.imageurl) { //need to upload file
            const res = await uploadFile(imageFile);
            if (res.code === 200) {
                newStaff.imageurl = res.data.image.url;
            } else {
                setLoading(false);
                setError(res.error)
                return;
            }
        }
        const res = await updateStaffDetail(newStaff);
        setLoading(false);
        if (res.code === 200) {
            setUserData(res.data.staff)
            navigate(-1);
        } else {
            setError(res.error);
        }
    }

    useEffect(() => {
        function handleResize() {
            const windscroll = $(window).scrollTop();
            if (windscroll >= 100) {
                $(".appHeader").removeClass("transparent")
            } else {
                $(".appHeader").addClass("transparent")
            }
        }

        window.addEventListener('scroll', handleResize)
        handleResize();
        return () => {
            window.removeEventListener('scroll', handleResize)
        }
    }, [])

    return (
        <>
            {loading && <Loader/>}
            {!!error && <ErrorDialog isOpen={true} content={error} onClose={() => setError('')}/>}
            <Header hasBack title={"Profile"}/>
            <SideMenu selected={MENUS.SETTINGS}/>
            <div id="appCapsule" className={"p-0"}>

                <div onClick={() => imageInputRef.current.click()} className="cover-img-wrapper">
                    <img src={imageUrl} className="cover-img" alt="image"/>
                    <input
                        style={{display: 'none'}}
                        ref={imageInputRef}
                        type="file"
                        className="form-control"
                        id="photo"
                        accept="image/*"
                        onChange={(e) => {
                            if (e.target?.files?.length > 0) {
                                setImageUrl(URL.createObjectURL(e.target.files[0]));
                                setImageFile(e.target.files[0]);
                            }
                        }}
                    />
                </div>
                <div className="section clients-edit mt-2">
                    {/*<div className="row m-0">*/}
                    {/*    <div className="col-6 ps-0">*/}
                    {/*        <div*/}
                    {/*            onClick={() => imageInputRef.current.click()}*/}
                    {/*            className="card img-card card-border" data-bs-toggle="modal"*/}
                    {/*            data-bs-target="#getPicturesDialog">*/}
                    {/*            <img src={imageUrl} className="card-img-top" alt="image"/>*/}
                    {/*            <div style={{display: 'flex'}}>*/}
                    {/*                <h4 style={{flex: 1}}>Select Photo</h4>*/}
                    {/*                {imageFile && <h4 onClick={handleRemoveImage} style={{flex: 1}}>Remove</h4>}*/}
                    {/*            </div>*/}
                    {/*            <input*/}
                    {/*                style={{display: 'none'}}*/}
                    {/*                ref={imageInputRef}*/}
                    {/*                type="file"*/}
                    {/*                className="form-control"*/}
                    {/*                id="photo"*/}
                    {/*                accept="image/*"*/}
                    {/*                onChange={(e) => {*/}
                    {/*                    if (e.target?.files?.length > 0) {*/}
                    {/*                        setImageUrl(URL.createObjectURL(e.target.files[0]));*/}
                    {/*                        setImageFile(e.target.files[0]);*/}
                    {/*                    }*/}
                    {/*                }}*/}
                    {/*            />*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {/* * Items */}
                    {/* details */}
                    <div className="section-title mt-3">Details</div>
                    <div className="card card-border">
                        <div className="card-body">
                            <form>
                                <div className="form-group basic">
                                    <div className="input-wrapper">
                                        <label className="label" htmlFor="Name">Staff Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="Name"
                                            value={name}
                                            onChange={e => setName(e.target.value)}
                                            maxLength={200}
                                        />
                                    </div>
                                </div>
                                <div className="form-group basic">
                                    <div className="input-wrapper">
                                        <label className="label" htmlFor="SurName">Surname</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="Surname"
                                            value={surname}
                                            onChange={e => setSurname(e.target.value)}
                                            maxLength={200}
                                        />
                                    </div>
                                </div>
                                <div className="form-group basic">
                                    <div className="input-wrapper">
                                        <label className="label" htmlFor="email">E-mail</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            id="email"
                                            value={email}
                                            onChange={e => setEmail(e.target.value)}
                                            maxLength={200}
                                        />
                                    </div>
                                </div>
                                <div className="form-group basic">
                                    <div className="input-wrapper">
                                        <label className="label" htmlFor="phone">Mobile</label>
                                        <input
                                            type="tel"
                                            id="phone"
                                            className="form-control"
                                            autoComplete="off"
                                            value={phonenumber}
                                            onChange={e => setPhone(e.target.value)}
                                            maxLength={15}
                                        />
                                    </div>
                                </div>
                                <div className="form-group basic">
                                    <div className="input-wrapper">
                                        <label className="label" htmlFor="description">Description</label>
                                        <textarea
                                            id="description"
                                            rows={2} className="form-control"
                                            value={note}
                                            onChange={e => setNote(e.target.value)}
                                            maxLength={500}
                                        />

                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    {/* * details */}
                    {/* More */}
                    <ul className="listview simple-listview transparent darkmode-transparent flush mt-4">
                        <li>
                            <div>More</div>
                            <div className="form-check form-switch">
                                <input className="form-check-input" type="checkbox" id="SwitchMore"
                                       checked={hasMore} onChange={(e) => setHasMore(e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="SwitchMore" id="itemsSwitchToggler"/>
                            </div>
                        </li>
                    </ul>
                    {
                        hasMore && <div id="itemsSwitchWrapper" className="card card-border">
                            <div className="card-body">
                                <form>
                                    <div className="form-group basic">
                                        <div className="input-wrapper">
                                            <label className="label" htmlFor="Gender">Gender</label>
                                            <select className="form-control custom-select" id="Gender"
                                                    value={gender}
                                                    onChange={(e) => setGender(e.target.value)}
                                            >
                                                <option value={0}>Male</option>
                                                <option value={1}>Female</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="form-group basic">
                                        <label className="label" htmlFor="birthdate">Birthdate (MM/DD/YYYY)</label>
                                        <InputMask
                                            id={"birthdate"}
                                            className="form-control"
                                            // maskPlaceholder={null}
                                            mask={"99/99/9999"}
                                            value={birthdate}
                                            onChange={e => setBirthdate(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-group basic">
                                        <div className="input-wrapper">
                                            <label className="label" htmlFor="Address">Address</label>
                                            <input type="text" className="form-control" id="Address"
                                                   value={address}
                                                   onChange={e => setAddress(e.target.value)}
                                                   maxLength={200}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group basic">
                                        <div className="input-wrapper">
                                            <label className="label" htmlFor="City">City</label>
                                            <input type="text" className="form-control" id="City"
                                                   value={city}
                                                   onChange={e => setCity(e.target.value)}
                                                   maxLength={200}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group basic">
                                        <div className="input-wrapper">
                                            <label className="label" htmlFor="Postal">Postal Code</label>
                                            <input type="text" className="form-control" id="Postal"
                                                   value={postal}
                                                   onChange={e => setPostal(e.target.value)}
                                                   maxLength={10}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group basic">
                                        <div className="input-wrapper">
                                            <label className="label" htmlFor="country">Country</label>
                                            <select className="form-control custom-select" id="country"
                                                    value={country}
                                                    onChange={(e) => setCountry(e.target.value)}
                                            >
                                                {COUNTRIES.map(country => <option key={country}
                                                                                  value={country}>{country}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    }
                    <div className="mt-4">
                        <a onClick={handleSave} className="btn btn-primary btn-shadow btn-lg btn-block mt-2">Save</a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default withUserAuth(Profile);
